import React, { useState, useEffect } from 'react'
import Header from '../partials/Header'
import '../mycomponents/StripeSub/StripeMain.css'
import Axios from 'axios'

const testimonials = [
    "Built for city agencies. Secure, compliant, and customizable",
    "More ground covered. Fewer delays. Better outcomes and more agency revenue",
    "Eliminate spreadsheet chaos with optimized scheduling and routing"
];

function GovIntro() {
    const [activeIndex, setActiveIndex] = useState(0)
    const [outgoingIndex, setOutgoingIndex] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', or null

    useEffect(() => {
      const interval = setInterval(() => {
        setOutgoingIndex(activeIndex); // Start fading out the current testimonial
        setTimeout(() => {
          setActiveIndex((current) => (current + 1) % testimonials.length);
          setOutgoingIndex(null); // Reset for the next entry
        }, 1000); // This should match the duration of the fade-out animation
      }, 8000); // Change paragraph every 8 seconds
  
      return () => clearInterval(interval);
    }, [activeIndex]);

    function handleDotClick(index) {
        setActiveIndex(index);
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return;
        
        setIsSubmitting(true);
        setSubmitStatus(null);
        
        const formData = new FormData(e.target);
        const name = formData.get('name');
        const organization = formData.get('organization');
        const email = formData.get('email');
        const additionalInfo = formData.get('additionalInfo');
        
        try {
            const response = await Axios.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/sendform`, {
                name,
                organization,
                email,
                additionalInfo
            });
            
            if (response.data.isSent) {
                setSubmitStatus('success');
                e.target.reset(); // Clear the form
                setTimeout(() => setSubmitStatus(null), 5000); // Clear success message after 5 seconds
            } else {
                setSubmitStatus('error');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="flex flex-col h-screen overflow-hidden">
            {/* Site header */}
            <Header />
            <div className="h-16"></div>

            {/* Page content */}
            <main className="flex-grow flex">
                {/* Visual Section */}
                <div className="innershadow hidden lg:flex w-full mt-5 mb-5 ml-5 pt-5 pr-5 pl-5 rounded-3xl bg-gradient-to-r from-myteal-500 to-myteal-300 flex-col justify-between items-center" style={{ height: 'calc(100vh - 120px)' }}>
                    <div style={{ maxWidth: 700 }} className="flex flex-col w-full">
                        {outgoingIndex !== null && (
                            <p key={`outgoing-${outgoingIndex}`} className="fadeOutLeft text-white text-3xl font-semibold mt-10">
                            {testimonials[outgoingIndex]}
                            </p>
                        )}
                        <p key={`incoming-${activeIndex}`} className={`fadeInRight text-white text-3xl font-semibold mt-10 ${outgoingIndex === null ? '' : 'hidden'}`}>
                            {testimonials[activeIndex]}
                        </p>
                        
                        {/* Carousel Navigation Dots */}
                        <div className="flex justify-start w-full mt-10">
                            <span onClick={() => handleDotClick(0)} className={`dot ${activeIndex === 0 ? 'active' : ''} cursor-pointer`}></span>
                            <span onClick={() => handleDotClick(1)} className={`dot ${activeIndex === 1 ? 'active' : ''} cursor-pointer`}></span>
                            <span onClick={() => handleDotClick(2)} className={`dot ${activeIndex === 2 ? 'active' : ''} cursor-pointer`}></span>
                        </div>
                    </div>

                    {/* Image remains at the bottom */}
                    <img className="plusvisual mt-auto" width="800px" height="425px" src={require('../images/routora-govpage-visual.png').default} alt="Routora Plus Visual" />
                </div>

                {/* Government Intro Section */}
                <div className="paymentcard flex flex-col justify-end mt-5 lg:mt-0" style={{ height: 'calc(100vh - 170px)' }}>
                    <div className="checkoutinfo px-8 pt-8 pb-0">
                        <div className="">
                            <h1 className="text-5xl font-bold text-myblue-900 text-left leading-tight">
                                Routora for
                            </h1>
                            <h1 className="text-5xl font-bold text-myblue-900 text-left leading-tight mb-5">
                                Government
                            </h1>
                            
                            <form onSubmit={handleFormSubmit} className="space-y-4">
                                <div>
                                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        required
                                        className="w-full px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        placeholder="Enter your full name"
                                    />
                                </div>
                                
                                <div>
                                    <label htmlFor="organization" className="block text-sm font-medium text-gray-700 mb-1">Organization *</label>
                                    <input
                                        type="text"
                                        id="organization"
                                        name="organization"
                                        required
                                        className="w-full px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        placeholder="Enter your organization name"
                                    />
                                </div>
                                
                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        required
                                        className="w-full px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        placeholder="Enter your email address"
                                    />
                                </div>
                                
                                <div>
                                    <label htmlFor="additionalInfo" className="block text-sm font-medium text-gray-700 mb-1">Additional Information</label>
                                    <textarea
                                        id="additionalInfo"
                                        name="additionalInfo"
                                        rows="2"
                                        className="w-full px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none text-sm"
                                        placeholder="Tell us about your specific needs or any questions you have..."
                                    ></textarea>
                                </div>
                                
                                {/* Status Messages */}
                                {submitStatus === 'success' && (
                                    <div className="bg-green-50 border border-green-200 text-green-800 px-3 py-2 rounded-lg text-sm">
                                        Thank you! Your demo request has been sent. We'll be in touch soon.
                                    </div>
                                )}
                                
                                {submitStatus === 'error' && (
                                    <div className="bg-red-50 border border-red-200 text-red-800 px-3 py-2 rounded-lg text-sm">
                                        There was an issue sending your request. Please try again or contact us directly.
                                    </div>
                                )}
                                
                                <button 
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`w-full text-white py-3 px-4 rounded-lg font-semibold transition-all duration-200 shadow-lg text-sm ${
                                        isSubmitting 
                                            ? 'bg-gray-400 cursor-not-allowed' 
                                            : 'bg-blue-500 cursor-pointer hover:bg-blue-600'
                                    }`}
                                >
                                    {isSubmitting ? 'Sending...' : 'Request Demo'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default GovIntro;